module.exports = "<style>\n\t.status-mts{\n\t\tbox-shadow: rgba(0, 0, 0, 0.2) 0px 5px 25px -2px;\n        margin-top: 30px;\n        height:50px;\n\t}\n\n\t.status-mts .selected,\n\t.status-mts .with-hover:hover:not(.disabled) {\n\t\tbox-shadow: none;\n\t\tcolor: #ffffff;\n\t\t\n\t}\n</style>\n<div style=\"\" class=\"lane status-mts\"></div>\n<textarea *ngIf=\"elementId\" id=\"{{elementId}}\"></textarea>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/wb/text/text-wb.component.html
// module id = ../../../../../src/app/wb/text/text-wb.component.html
// module chunks = main